export default {
  reports: 'Berichte',
  components: 'Komponenten',
};
